import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import LoadingSpinner from '../components/widgets/LoadingSpinner';
const authActions = require('../features/auth/authSlice');

export const ProtectedRoutes = () => {
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {

    if (! authState.user) {
      dispatch(authActions.getAccount());
    }
  }, [dispatch, authState.user]);


  if (authState.loading || authState.loadingUser)
    return <LoadingSpinner />;

  //  if we're no longer signed in, then return to the home page
  if (! authState.isLoggedIn)
    return <Navigate to="/" replace />;

  if (! authState.user)
    return <LoadingSpinner />;  

  return <Outlet/>;

};
